"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'ModelFilter_1_0_0',
  resetLabel: 'Reset',
  label: null,
  notes: {
    title: null,
    text: 'To change your selection, simply reset your choices below.'
  },
  filters: [{
    code: 'fuel_type',
    label: 'FUEL',
    filteringOptions: [{
      id: 'N/A',
      type: 'fuel_type',
      code: 'N/A',
      label: 'N/A',
      image: {
        image: '/content/dam/mitsubishi-motors-us/images/icons/fuel_type_N/A.svg',
        altText: ''
      },
      titleAndText: {
        title: 'N/A',
        text: null
      },
      includedOptions: [],
      selected: true
    }]
  }, {
    code: 'transmission_type',
    label: 'TRANSMISSION',
    filteringOptions: [{
      id: 'CVT',
      type: 'transmission_type',
      code: 'CVT',
      label: 'CVT',
      image: {
        image: '/content/dam/mitsubishi-motors-us/images/icons/transmission_type_CVT.svg',
        altText: ''
      },
      titleAndText: {
        title: 'CVT',
        text: null
      },
      includedOptions: [],
      selected: true
    }]
  }, {
    code: 'drive_train',
    label: 'DRIVE',
    filteringOptions: [{
      id: '2WD',
      type: 'drive_train',
      code: '2WD',
      label: '2WD',
      image: {
        image: '/content/dam/mitsubishi-motors-us/images/icons/drive_train_2WD.svg',
        altText: ''
      },
      titleAndText: {
        title: '2WD',
        text: null
      },
      includedOptions: [],
      selected: false
    }, {
      id: 'SE',
      type: 'drive_train',
      code: 'SE',
      label: 'SE',
      image: {
        image: '/content/dam/mitsubishi-motors-us/images/icons/drive_train_SE.svg',
        altText: ''
      },
      titleAndText: {
        title: 'SE',
        text: null
      },
      includedOptions: [],
      selected: false
    }, {
      id: 'AWC',
      type: 'drive_train',
      code: 'AWC',
      label: 'AWC',
      image: {
        image: '/content/dam/mitsubishi-motors-us/images/icons/drive_train_AWC.svg',
        altText: ''
      },
      titleAndText: {
        title: 'AWC',
        text: null
      },
      includedOptions: [],
      selected: false
    }, {
      id: 'GT',
      type: 'drive_train',
      code: 'GT',
      label: 'GT',
      image: {
        image: '/content/dam/mitsubishi-motors-us/images/icons/drive_train_GT.svg',
        altText: ''
      },
      titleAndText: {
        title: 'GT',
        text: null
      },
      includedOptions: [],
      selected: false
    }]
  }]
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;